import PropTypes from 'prop-types'
import { useState, useRef, useEffect } from 'react'
import styles from './Adjuntos.module.css'

export const Adjuntos = ({ adjunto }) => {
  const [imagenAmpliada, setImagenAmpliada] = useState(null)
  const imageRef = useRef(null)
  const overlayRef = useRef(null)

  useEffect(() => {
    if (imagenAmpliada && overlayRef.current) {
      overlayRef.current.scrollIntoView({ behavior: 'smooth', block: 'center' })
    }
  }, [imagenAmpliada])

  const handleImageClick = (url) => {
    setImagenAmpliada(url)
  }

  return (
    <>
      {imagenAmpliada && (
        <div className={styles.overlay} ref={overlayRef} onClick={() => setImagenAmpliada(null)}>
          <img alt="Imagen ampliada" src={imagenAmpliada} className={styles.overlayImg} />
        </div>
      )}
      {adjunto?.length > 0 &&
        adjunto.map((adj) => (
          <div key={adj.idAdjunto} className={styles.archivoWrapper} ref={imageRef}>
            {adj?.contentType?.startsWith('image/') ? (
              <img
                src={adj.url}
                alt={adj.nombre}
                className={styles.imgadj}
                onClick={() => handleImageClick(adj.url)}
              />
            ) : adj?.contentType === 'application/pdf' ? (
              <a
                href={adj.url}
                target="_blank"
                rel="noopener noreferrer"
                className={styles.archivoItem}
              >
                <i className="fa fa-file-pdf-o" />
                <span>{adj.nombre}</span>
              </a>
            ) : (
              <a href={adj.url} download={adj.nombre} className={styles.archivoItem}>
                <i className="fa fa-file-o" />
                <span>{adj.nombre}</span>
              </a>
            )}
          </div>
        ))}
    </>
  )
}

Adjuntos.propTypes = {
  adjunto: PropTypes.arrayOf(PropTypes.object)
}
